import { createTranslationObject } from '../helper';
import { Locale } from 'chaika-enums';
export const amTranslations = createTranslationObject(Locale.Am);
